import React from "react";
import {BasketDispatchContext} from '../providers';

function useDispatchBasket() {
    return React.useContext(BasketDispatchContext);
}

function useDispatchBa(Id) {
    let dis = React.useContext(BasketDispatchContext);
    dis([{ms:"sdaasd"}])
    return true;
}

export {useDispatchBasket,useDispatchBa}
